import LocationStatusList from "../../components/LocationStatusList";

const LocationStatusListPage = () => {
  return <LocationStatusList />;
};

export default LocationStatusListPage;
